import React, { Component } from 'react';
import Theme from '../../theme';
import { Field } from 'redux-form';
import PhoneInput from 'react-native-phone-input';
import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  Image,
} from 'react-native';
import TextInput from './TextInput';
import Dropdown from './Dropdown';
import * as MobileNumberComp from './MobileNumber';
import { getDialCodeFromNumberOrFallbackToAus } from '../../utils/string-manipulation';

const { width } = Dimensions.get('window');
const isMobile = width <= 550;

class MobileNumber extends Component {
  state = { defaultCountry: '' };

  componentDidMount = async () => {
    if (this.phone) {
      const pickerData = this.getCountryDropDown();
      this.setState({ pickerData });

      if (pickerData) {
        let pickerDataWithImage = pickerData.map(country => {
          country.value = country.dialCode;
          country.thumbnail = this.getCountryPickerElement(
            country.image,
            country.dialCode
          );
          return country;
        });
        this.setState({ pickerDataWithImage, defaultCountry: this.defaultCountry() });
      }
    }
  };

  getCountryPickerElement = (thumbnailLink, dialCode) => {
    let thumbnailElement = <View style={styles.thumbnailElementView} />;
    if (thumbnailLink) {
      thumbnailElement = (
        <View style={styles.thumbnailElement}>
          <Image
            resizeMode={"cover"}
            style={styles.thumbnailElementImageWeb}
            source={{ uri: thumbnailLink }}
          />
          <Text style={styles.thumbnailText}>{dialCode}</Text>
        </View>
      );
    }
    return thumbnailElement;
  };

  defaultCountry = () => {
    if (!this.phone) {
      return;
    }
    const pickerData = this.getCountryDropDown();
    const mobileNumber = this.props.input.value;
    if (mobileNumber) {
      constdialCode = getDialCodeFromNumberOrFallbackToAus(mobileNumber, pickerData);
      const indexOfDialCode = pickerData.map(e => e.dialCode).indexOf(dialCode);
      return pickerData[indexOfDialCode].dialCode;
    } else {
      const indexOfAus = pickerData.map(e => e.iso2).indexOf("au");
      return pickerData[indexOfAus].dialCode;
    }
  };

  getCountryDropDown = () => {
    return this.phone.getPickerData();
  };

  focus = () => {
    if (this.input) this.input.focus();
  }

  getDropdownRowWidth = () => {
    const isMobile = window.innerWidth <= 550;
    if (isMobile) {
      return "70%";
    }
    return "25%";
  };

  render() {
    const {
      defaultCountry,
      pickerDataWithImage,
    } = this.state;

    return (
      <View style={styles.phoneNumberContainer}>
        <View style={styles.phoneInputContainerWeb}>
          <PhoneInput
            initialCountry="au"
            ref={ref => this.phone = ref}
            style={styles.phoneInputWeb}
          />
          <Field
            forwardRef
            webAbsolute
            showThumbnailInLabel
            name="countryCode"
            showLabel={false}
            valueKey="dialCode"
            displayKey="label"
            isRequired={false}
            defaultValue={defaultCountry}
            placeholder="thumbnail"
            options={pickerDataWithImage ? pickerDataWithImage : []}
            component={Dropdown}
            isSearchable={true}
            rowWidth={this.getDropdownRowWidth()}
            height="100%"
            ref={ref => {
              this.countryCode = ref;
            }}
          />
        </View>
        <View style={styles.mobileNumberContainerWeb}>
          <TextInput
            showLabel={false}
            textInputStyle={{ width: '100%' }}
            {...this.props}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  phoneInput: {
    backgroundColor: Theme.GREY_LIGHT,
    borderRadius: 3,
    paddingHorizontal: 10,
    paddingVertical: 10,
    marginTop: 5,
    marginBottom: 5,
    width: "100%"
  },
  phoneInputWeb: {
    display: "none"
  },
  phoneInputContainerWeb: {
    width: "35%",
    marginRight: 5,
    marginTop: 6
  },
  mobileNumberContainerWeb: {
    flex: 1,
  },
  phoneNumberContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
  },
  thumbnailElement: {
    flexDirection: "row",
    alignItems: "flex-start"
  },
  thumbnailElementView: {
    backgroundColor: Theme.WHITE,
    width: 25,
    height: 15,
    flexDirection: "row",
    alignItems: "flex-start"
  },
  thumbnailElementImageWeb: {
    width: 25,
    height: 15,
    marginTop: 5
  },
  thumbnailText: {
    marginLeft: 5,
    marginTop: 2
  },
});

export default MobileNumber;
